module.exports = __webpack_public_path__ + "assets/5b415c55258960f929a51736c4c6cd3d.jpg";